import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GET_REASSIGNMENT_FUND_LIST, GET_REASSIGNMENT_CXO_RM_LIST, GET_REASSIGNMENT_INVESTOR_LIST, GET_REASSIGNMENT_HISTORY, UPDATE_CXORM_DETAILS, DOWNLOAD_FILE, APPROVERMCXOUPLOAD, UPDATE_HISTORY_COUNT, VALIDATE_FILE, GET_MANUAL_REASSIGNMENT_LIST, GET_MANUAL_UPDATEHISTORY_LIST, MANUAL_UPDATE_CXORM_DETAILS, DOWNLOAD_MANUAL_UPDATE_HISTORY_FILE, GET_RTA_HISTORY, DOWNLOAD_CXO_RM_UPDATED_RECORDS, APPLICATION_FOLIO_PAN_LIST } from '../../core/constants/api-endpoints';
import { ACCESS_TOKEN, AUTHORIZATION, BEARER_TOKEN_PREFIX } from '../../core/constants/app-strings';
import * as XLSX from 'xlsx';
import { ToastController } from '@ionic/angular';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class ReassignmentService {

  constructor(private http: HttpClient) { }

  getFunds(payload: any): Observable<any> {
    const headers = new HttpHeaders()
      .set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`)
      .set('Content-Type', 'application/json');

    return this.http.post(
      `${environment.APIURL}${GET_REASSIGNMENT_FUND_LIST}`,
      payload,
      { headers }
    );
  }

  getCXORM(payload: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set(
        AUTHORIZATION,
        `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
      );

    return this.http.post(
      `${environment.APIURL}${GET_REASSIGNMENT_CXO_RM_LIST}`,
      payload,
      { headers }
    );
  }

  getInvestorList(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${GET_REASSIGNMENT_INVESTOR_LIST}`, payload, { headers });
  }

  getCXORMReassignmentHistory(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${GET_REASSIGNMENT_HISTORY}`, payload, { headers });
  }

  updateCXORMDetails(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${UPDATE_CXORM_DETAILS}`, payload, { headers });
  }

  uploadFile(file: File, folderPath: string): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    const formData = new FormData();
    formData.append('File', file, file.name);
    formData.append('FolderPath', folderPath);
    return this.http.post(`${environment.APIURL}/api/v1/document/UploadFile`, formData, { headers, reportProgress: false });
  }

  downloadFile(fileName: string, folderPath: string): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${DOWNLOAD_FILE}`, { FileName: fileName, FolderPath: folderPath }, { headers });
  }

  updateHistoryCount(payload: { Role: string }): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );

    return this.http.post(
      `${environment.APIURL}${UPDATE_HISTORY_COUNT}`,
      payload,
      { headers }
    );
  }

  approveRMCXOUpload(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${APPROVERMCXOUPLOAD}`, payload, { headers });
  }

  validateFile(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${VALIDATE_FILE}`, payload, { headers });
  }

  getManualReassignmentList(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${GET_MANUAL_REASSIGNMENT_LIST}`, payload, { headers });
  }

  getManualUpdateHistoryList(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${GET_MANUAL_UPDATEHISTORY_LIST}`, payload, { headers });
  }

  ManualUpdate(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${MANUAL_UPDATE_CXORM_DETAILS}`, payload, { headers });
  }

  DownloadCXORMUpdatedRecords(uploadId: number, type: string): Observable<any> {

    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set(AUTHORIZATION, `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`);

    const body = {
      UploadId: uploadId,
      Type: type
    };

    return this.http.post(
      `${environment.APIURL}${DOWNLOAD_CXO_RM_UPDATED_RECORDS}`,
      body,
      { headers }
    );
  }

  getRTAHistory(payload: any): Observable<any> {
    const headers = new HttpHeaders().set(
      AUTHORIZATION,
      `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
    );
    return this.http.post(`${environment.APIURL}${GET_RTA_HISTORY}`, payload, { headers });
  }

  getApplicationFolioPanList(payload: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set(
        AUTHORIZATION,
        `${BEARER_TOKEN_PREFIX}${localStorage.getItem(ACCESS_TOKEN)}`
      );

    return this.http.post(
      `${environment.APIURL}${APPLICATION_FOLIO_PAN_LIST}`,
      payload,
      { headers }
    );
  }

  async generateReassignmentExcel(data: any[], fileName: string, sheetName: string): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    const headerConfig = [
      { key: "folioNo", label: "Folio No" },
      { key: "applicationNo", label: "Application No" },
      { key: "status", label: "Status" },
      { key: "investorName", label: "Investor Name" },
      { key: "pan", label: "PAN" },
      { key: "fundName", label: "Fund Name" },
      { key: "distributorARN", label: "Distributor ARN" },
      { key: "distributorName", label: "Distributor Name" },
      { key: "existingRMName", label: "Existing RM Name" },
      { key: "existingRMEmail", label: "Existing RM Email" },
      { key: "existingRMCode", label: "Existing RM Code" },
      { key: "newRMName", label: "New RM Name" },
      { key: "newRMEmail", label: "New RM Email" },
      { key: "newRMCode", label: "New RM Code" },
      { key: "existingCXOName", label: "Existing CXO Name" },
      { key: "existingCXOEmail", label: "Existing CXO Email" },
      { key: "existingCXOMobile", label: "Existing CXO Mobile" },
      { key: "newCXOName", label: "New CXO Name" },
      { key: "newCXOEmail", label: "New CXO Email" },
      { key: "newCXOMobile", label: "New CXO Mobile" }
    ];

    // Header row
    const headerRow = worksheet.addRow(headerConfig.map(h => h.label));

    // Style
    headerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } };
      cell.alignment = { horizontal: 'left' };   // ⭐ LEFT ALIGN
    });

    // Data rows
    data.forEach(row => {
      const addedRow = worksheet.addRow(headerConfig.map(h => row[h.key] ?? ""));

      addedRow.eachCell(cell => {
        cell.alignment = { horizontal: 'left' }; // ⭐ LEFT ALIGN
      });
    });

    // Autofit
    worksheet.columns.forEach(col => {
      let max = 12;
      col.eachCell({ includeEmpty: true }, cell => {
        max = Math.max(max, cell.value?.toString().length || 0);
      });
      col.width = Math.min(max + 4, 40);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
  }
}
